import { useState } from 'react';
import { Typography, Spin, message } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import { docmanService } from '@/services/docman.service';

const { Link } = Typography;

interface FileViewerProps {
  fileName: string;
  fileUrl: string;
  documentId: string;
  fileSizeBytes?: number;
}

export function FileViewer({
  fileName,
  documentId,
  fileSizeBytes,
}: FileViewerProps) {
  const [isLoading, setIsLoading] = useState(false);

  const formatFileSize = (bytes: number) => {
    return (bytes / 1024 / 1024).toFixed(2).replace('.', ',');
  };

  const handleOpen = async () => {
    setIsLoading(true);

    try {
      const docId = documentId.startsWith('docman/')
        ? documentId.replace('docman/', '')
        : documentId;

      const newUrl = await docmanService.getImageUrl(docId);

      window.open(newUrl, '_blank');
    } catch (err) {
      message.error('Erro ao abrir arquivo. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {isLoading ? (
        <>
          <Spin size="small" />
          <span style={{ fontSize: 13, color: '#1890ff' }}>Carregando...</span>
        </>
      ) : (
        <>
          <FileOutlined style={{ color: '#1890ff' }} />
          <Link onClick={handleOpen} style={{ cursor: 'pointer' }}>
            {fileName}
          </Link>
          {fileSizeBytes && (
            <span style={{ fontSize: 11, color: '#999' }}>
              ({formatFileSize(fileSizeBytes)} MB)
            </span>
          )}
        </>
      )}
    </div>
  );
}
